function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 7.81v8.38c0 3.64-2.17 5.81-5.81 5.81H7.81c-1.49 0-2.73-.36-3.68-1.05-.42-.29-.79-.66-1.08-1.08C2.36 18.92 2 17.68 2 16.19V7.81C2 4.17 4.17 2 7.81 2h8.38c1.49 0 2.73.36 3.68 1.05.42.29.79.66 1.08 1.08.69.95 1.05 2.19 1.05 3.68z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.95 4.13L4.13 20.95c-.42-.29-.79-.66-1.08-1.08L19.87 3.05c.42.29.79.66 1.08 1.08zM18.5 14.75h-1.69V13c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.75H13.5c-.41 0-.75.34-.75.75s.34.75.75.75h1.81V18c0 .41.34.75.75.75s.75-.34.75-.75v-1.75h1.69c.41 0 .75-.34.75-.75s-.34-.75-.75-.75zm-8-6.5h-5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75z"
})));